import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFlipboard$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFlipboard extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'efe759dc09864214bce21f21e5387c5499ba85cf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8822195374ca3eab9d72d842a8bfa31340b060b3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'acb37ba31cee257b93a4755788597ee499fc4457', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 2v18H2V2zM5.6 5.6v10.8h3.6v-3.6h3.6V9.2h3.6V5.6z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-flipboard", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-flipboard"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-flipboard":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFlipboard$1);
            }
            break;
    } });
}

const CosmosIconFlipboard = CosmosIconFlipboard$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFlipboard, defineCustomElement };
